import api from './api';

// 공지사항 관련 API 호출 함수들
export const noticesApi = {
  getHiddenNotices: async () => (await api.getAuth('/notices/hidden')).data,
  setHidden: async (id, isHidden) =>
    (await api.putAuth(`/notices/${id}/visibility`, { isHidden })).data,
  // 공지사항 목록 조회 (고정 공지 제외)
  getAllNotices: async (page = 1, size = 20) => {
    const response = await api.getPublic(`/notices?page=${page}&size=${size}&locale=ko`);
    return response.data;
  },

  // 고정 공지사항 목록 조회
  getPinnedNotices: async () => {
    const response = await api.getPublic(`/notices/pinned?locale=ko`);
    return response.data;
  },

  // 공지사항 상세 조회
  getNoticeById: async (id) => {
    const response = await api.getAuth(`/notices/${id}?locale=ko`);
    return response.data;
  },

  // 슬러그로 공지사항 상세 조회
  getNoticeBySlug: async (slug) => {
    const response = await api.getAuth(`/notices/by-slug/${slug}?locale=ko`);
    return response.data;
  },

  // 공지사항 생성
  createNotice: async (formData) => {
    const response = await api.postAuth(`/notices`, formData);
    return response.data;
  },

  // 공지사항 수정
  updateNotice: async (id, data) => {
    const response = await api.putAuth(`/notices/${id}`, data);
    return response.data;
  },

  // 공지사항 삭제
  deleteNotice: async (id) => {
    const response = await api.deleteAuth(`/notices/${id}`);
    return response.data;
  },

  // 공지사항 고정/해제
  togglePin: async (id, isPinned) => {
    const response = await api.putAuth(`/notices/${id}`, { isPinned });
    return response.data;
  },

  // 공지사항 댓글 목록 조회
  getComments: async (noticeId) => {
    const response = await api.getAuth(`/comments?article_type=NOTICE&article_id=${noticeId}`);
    return response.data;
  },

  // 공지사항 댓글 작성
  addComment: async (noticeId, content, parentId = null, mentionedUserId = null) => {
    const payload = {
      articleType: 'NOTICE',
      articleId: Number(noticeId),
      content: content,
    };

    if (parentId !== null) {
      payload.parentId = parentId;
    }
    if (mentionedUserId !== null) {
      payload.mentionedUserId = mentionedUserId;
    }

    const response = await api.postAuth('/comments', payload);
    return response.data;
  },

  // 공지사항 북마크 추가
  addBookmark: async (noticeId) => {
    const response = await api.postAuth('/bookmarks', {
      itemType: 'NOTICE',
      itemId: Number(noticeId),
    });
    return response.data;
  },

  // 공지사항 북마크 삭제
  deleteBookmark: async (noticeId) => {
    const response = await api.deleteAuth(`/bookmarks/notice/${noticeId}`);
    return response.data;
  },
};
